<template>
  <layout-ucenter>
    <!-- menu -->
    <template slot="menu">
      <el-menu mode="vertical" :router="true" default-active="1">
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-document"></i> 示例页面</template>
          <el-menu-item index="/demo/list">列表页</el-menu-item>
          <el-menu-item index="/demo/form">表单页</el-menu-item>
        </el-menu-item-group>
      </el-menu>
    </template>
  </layout-ucenter>
</template>

<script>
  import layoutUcenter from './layout-ucenter'

  export default {
    components: {
      layoutUcenter
    }
  }
</script>

<style>
.el-menu {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// demo-container.vue?fb1aa60c